import React, { useEffect, useState, Fragment, useContext } from 'react';
import {	Stack, TableRow, Button, TextField } from '@mui/material';
import Subtitle from '../ui/Subtitle';
import { backendFetch, backendPostWithJson, backendPutWithJson } from '../../backend/backend';
import { tokenContext } from '../TokenProvider';
import { TSCell, TSTable } from '../ui/TableStructure';

const PlayersPage = () => {

	const [players,setPlayers]=useState([]);
	const [update,setUpdate]=useState(false);
	const [newPlayerName,setNewPlayerName]=useState("");
	const {token,dropAdmin}=useContext(tokenContext);

	const forceUpdate=() => {
		setUpdate((update)=>!update);
	}

	useEffect(()=>{
		async function fetchData() {
			const players=await backendFetch('players');
			setPlayers(players);
		}
		fetchData();
	},[update]);

	const setActiveStatus=async (player,active)=>{
		await backendPutWithJson(token,dropAdmin,`players/${player}`,{active:JSON.stringify(active)});
		forceUpdate();
	}

	const addPlayer=async ()=>{
		await backendPostWithJson(token,dropAdmin,`players/${newPlayerName}`,{})
		setNewPlayerName((newPlayerName)=>"");
		forceUpdate();
	}

	const playerCells=()=>{
		return(
			<Fragment>
				{players.map((p,i)=>
					<TableRow key={i}>
						<TSCell>{p.name}</TSCell>
						<TSCell>{p.active?"Active":"Inactive"}</TSCell>
						<TSCell>
							<Button variant="contained" sx={{width:{xs:120,sm:150}}}
									onClick={()=>setActiveStatus(p.name,!p.active)}>
								{p.active?"Deactivate":"Activate"}
							</Button>
						</TSCell>
					</TableRow>
				)}
				<TableRow key="none">
					<TSCell>
						<TextField	value={newPlayerName}
												onChange={(e)=>setNewPlayerName(e.target.value)}
												onKeyPress={(e)=>{if (e.key==='Enter'){addPlayer();}}}/>
					</TSCell>
					<TSCell></TSCell>
					<TSCell>
						<Button variant="contained" sx={{width:{xs:120,sm:150}}}
								onClick={addPlayer} >
							Add
						</Button>
					</TSCell>
				</TableRow>
			</Fragment>
		)
	}

	return(
		<Stack spacing="0">
			<Subtitle text="Players"/>
			<TSTable headings={["Name","Status","Actions"]} sx={{width:{sm:500},maxWidth:500}}>
						{playerCells()}
			</TSTable>
		</Stack>
	)
};

export default PlayersPage;
